<p-toast></p-toast>

<ng-container *ngIf="this.loaded; else loading">
  <h5 *ngIf="showHeader">{{ selectedTargetName }} Definitions</h5>

  <div *ngIf="this.definitions?.length > 0; else noDefinitions">
    <div class="formgrid grid">
      <ng-container
        *ngFor="let definition of definitions; let defIndex = index"
      >
        <div
          *ngIf="definition.children.length"
          [class]="
            !verticalLayout && defIndex < definitions.length - 1
              ? 'field col-12 md:col-3'
              : 'field col-12'
          "
          class="col-12"
        >
          <p>
            <strong *ngIf="showLabels">{{
              definition.data.value | uppercase
            }}</strong>
          </p>
          <ng-container
            *ngIf="
              selectedTarget === 2 &&
                (definition.data.value.toLowerCase() === 'departments' ||
                  definition.data.value.toLowerCase() === 'department' ||
                  definition.data.value.toLowerCase() === 'categories' ||
                  definition.data.value.toLowerCase() === 'category' ||
                  definition.data.value.toLowerCase() === 'brands' ||
                  definition.data.value.toLowerCase() === 'brand');
              else customDefinition
            "
          >
            <ng-container
              *ngIf="
                definition.data.value.toLowerCase() === 'brands' ||
                definition.data.value.toLowerCase() === 'brand'
              "
            >
              <ng-container *ngIf="productOwner || reporting">
                <ng-container
                  *ngIf="currentBrands?.children?.length; else normalBrands"
                >
                  <span class="p-fluid mb-2">
                    <p-dropdown
                      (onChange)="handleDefinitionBrandChange($event)"
                      [disabled]="!editing"
                      [ngModel]="selectedBrand"
                      [options]="selectedBrandsOptions"
                      [placeholder]="
                        'Brands (' + selectedBrandsOptions?.length + ')'
                      "
                      [showClear]="!!selectedBrand"
                      dataKey="id"
                      optionLabel="name"
                    ></p-dropdown>
                  </span>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="!productOwner && !reporting">
                {{ selectedBrand?.name || 'No Brand' }}
              </ng-container>
            </ng-container>

            <!-- Department logic -->
            <ng-container
              *ngIf="
                definition.data.value.toLowerCase() === 'departments' ||
                definition.data.value.toLowerCase() === 'department'
              "
            >
              <!--
              TODO: dataKey wont select the item structure must be different.... -->
              <ng-container *ngIf="productOwner || reporting">
                <ng-container
                  *ngIf="
                    currentDepartments?.children?.length > 0;
                    else normalDepartments
                  "
                >
                  <span class="p-fluid mb-2">
                    <p-dropdown
                      (onChange)="handleDefinitionDepartmentChange($event)"
                      [disabled]="!editing"
                      [ngModel]="selectedDepartment"
                      [options]="selectedDepartmentOptions"
                      [placeholder]="
                        'Departments (' +
                        currentDepartments.children.length +
                        ')'
                      "
                      [showClear]="true"
                      dataKey="id"
                      optionLabel="name"
                    ></p-dropdown>
                  </span>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="!productOwner && !reporting">
                {{ selectedDepartment?.name || 'No Department' }}
              </ng-container>
            </ng-container>

            <!-- Category Logic -->
            <ng-container
              *ngIf="
                definition.data.value.toLowerCase() === 'categories' ||
                definition.data.value.toLowerCase() === 'category'
              "
            >
              <ng-container *ngIf="productOwner || reporting">
                <ng-container
                  *ngIf="
                    currentCategories?.children?.length > 0;
                    else normalCategories
                  "
                >
                  <span class="p-fluid mb-2">
                    <p-dropdown
                      (onChange)="handleDefinitionCategoryChange($event)"
                      [disabled]="!editing"
                      [ngModel]="selectedCategory"
                      [options]="selectedCategoryOptions"
                      [placeholder]="
                        'Categories (' + currentCategories.children.length + ')'
                      "
                      [showClear]="true"
                      optionLabel="name"
                    ></p-dropdown>
                  </span>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="!productOwner && !reporting">
                {{ selectedCategory?.name || 'No Category' }}
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-template #customDefinition>
            <ng-container *ngIf="definition?.children?.length; else noChildren">
              <span class="p-fluid mb-2">
                <p-dropdown
                  #definitionSelector
                  (onChange)="
                    updateDefinitionSelection(
                      [definitionSelector.value],
                      definition.data.id
                    )
                  "
                  *ngIf="singleSelection"
                  [(ngModel)]="currentDefinitions[definition.data.id][0]"
                  [disabled]="!editing"
                  [options]="definition.children"
                  [placeholder]="
                    definition.data?.value +
                    ' (' +
                    definition.children?.length +
                    ')'
                  "
                  [showClear]="true"
                  dataKey="id"
                  optionLabel="data.value"
                  optionValue="data"
                ></p-dropdown>
              </span>

              <ng-container *ngIf="!singleSelection">
                <span class="p-fluid">
                  <p-multiSelect
                    #definitionSelector
                    (onClick)="
                      updateDefinitionSelection(
                        this.definitionSelector.value,
                        definition.data.id
                      )
                    "
                    *ngIf="definition.children?.length > 0"
                    [(ngModel)]="currentDefinitions[definition.data.id]"
                    [defaultLabel]="
                      definition.data?.value +
                      ' (' +
                      definition.children?.length +
                      ')'
                    "
                    [disabled]="!editing"
                    [options]="definition.children"
                    dataKey="id"
                    display="chip"
                    filterMatchMode="contains"
                    optionDisabled="inactive"
                    optionLabel="data.value"
                    optionValue="data"
                  >
                  </p-multiSelect>
                </span>
              </ng-container>
            </ng-container>

            <ng-template #noChildren>
              <!-- <p>There are no definitions defined for {{definition.data.value}}.</p> -->
              <!--              There are no options for the definition <strong>{{definition.data.value}}</strong>.-->
              <!--              <a-->
              <!--                *bomaHasPermissions="['edit-definitions']"-->
              <!--                [routerLink]="['/', 'admin', 'definitions', 'view']"-->
              <!--              >Create your first one now.</a-->
              <!--              >-->
            </ng-template>
          </ng-template>
        </div>
      </ng-container>
    </div>

    <div *ngIf="targetId && editing" class="flex justify-content-end">
      <button
        (click)="linkDefinitionsToTarget()"
        [disabled]="saving"
        [label]="saving ? 'Saving..' : 'Save'"
        class="p-button flex align-items-center justify-content-end"
        icon="
             material-icons-round mi-save
            "
        pButton
        pRipple
        type="button"
      ></button>
    </div>
  </div>

  <!-- END THE DROP DOWN VERSION -->

  <ng-container *ngIf="complexDefinitions">
    <ng-container *ngIf="this.definitions?.length > 0; else noDefinitions">
      <div class="card my-2 p-1">
        <div class="grid formgrid justify-content-center">
          <div class="col-12">This</div>
          <div class="col">
            <ul class="breadcrumb-list">
              <li *ngFor="let item of definitionIdTree; let i = index">
                <a (click)="loadChildDefinitions(item.id, i)">{{
                  item.label
                }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Chips -->

      <div class="my-2 p-1">
        <div class="grid formgrid justify-content-center">
          <div class="col-12">
            <p>Selected Definitions</p>
          </div>
          <div class="col card">
            <ul class="badge-list">
              <li
                (click)="linkDefinition(item)"
                *ngFor="let item of linkedDefinitions; let i = index"
                class="p-chips-token"
              >
                <span class="p-chips-token-label ng-star-inserted">
                  {{ item.value }}
                </span>
                <span
                  class="p-chips-token-icon pi pi-times-circle ng-star-inserted"
                ></span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card">
        <p-treeTable
          (onNodeSelect)="nodeSelect($event)"
          [(selection)]="selectedNode"
          [columns]="cols"
          [lazy]="true"
          [value]="definitions"
          dataKey="id"
          selectionMode="single"
        >
          <ng-template let-columns pTemplate="header">
            <tr>
              <th *ngFor="let col of columns">
                {{ col.header }}
              </th>
              <th><!-- actions --></th>
            </tr>
          </ng-template>
          <ng-template
            let-columns="columns"
            let-rowData="rowData"
            let-rowNode
            pTemplate="body"
          >
            <tr [ttRow]="rowNode" [ttRow]="rowNode" [ttSelectableRow]="rowNode">
              <td *ngFor="let col of columns; let i = index">
                <p-treeTableToggler
                  *ngIf="i == 0"
                  [rowNode]="rowNode"
                ></p-treeTableToggler>
                {{ rowData[col.field] }}
              </td>
              <td>
                <button
                  (click)="linkDefinition(rowData)"
                  *ngIf="rowData.entityId && rowData.isSelectable"
                  class="p-button"
                  label="Link Definition"
                  pButton
                  pRipple
                  pToolTip="Link definition"
                  type="button"
                ></button>
              </td>
            </tr>
          </ng-template>
        </p-treeTable>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #normalDepartments>
  <div class="p-fluid mb-2">
    <boma-department-selector
      (updateData)="handleDepartmentChange($event)"
      [department]="selectedDepartment || null"
      [disabled]="!editing"
      [placeHolderText]="placeholder + ' Departments'"
    >
    </boma-department-selector>
  </div>
</ng-template>

<ng-template #normalBrands>
  <div class="p-fluid mb-2">
    <p-dropdown
      (onChange)="handleDefinitionBrandChange($event)"
      [disabled]="!editing"
      [ngModel]="selectedBrand"
      [options]="brandOptions"
      [placeholder]="'Brands (' + brandOptions?.length + ')'"
      [showClear]="!!selectedBrand"
      dataKey="id"
      optionLabel="name"
    ></p-dropdown>
  </div>
</ng-template>

<ng-template #normalCategories>
  <div class="p-fluid mb-2">
    <boma-category-selector
      (updateCategories)="handleCategories($event)"
      [disabled]="!editing"
      [multipleCategories]="true"
      [placeholder]="placeholder + ' Categories'"
    ></boma-category-selector>
  </div>
</ng-template>

<ng-template #noDefinitions>
  <ng-container *ngTemplateOutlet="normalCategories"></ng-container>

  <ng-container *ngTemplateOutlet="normalBrands"></ng-container>

  <ng-container *ngTemplateOutlet="normalDepartments"></ng-container>

  <p-messages severity="info">
    <ng-template pTemplate>
      <p>
        There are no custom grouping definitions defined yet.
        <a
          *permissionChecker="{
            permissions: ['edit-definitions'],
            requirement: 'all'
          }"
          routerLink="/admin/definitions/view"
          >Go to definitions under admin to create your first one.</a
        >
      </p>
    </ng-template>
  </p-messages>
</ng-template>

<ng-template #loading>
  <boma-anim-spinning-loader [size]="40"></boma-anim-spinning-loader>
</ng-template>
